export const setPageTitle = (pageTitle) => {
    document.title = pageTitle;
};